import { createStore } from 'vuex';
import axios from '@/plugins/axios';
import moment from 'moment-timezone';

export default createStore({
  state: {
    user: null,
    token: '',
    token_expires_at: '',
    roles: [],
  },
  getters: {
    isAuthenticated(state) {
      if (!state.token) return false;
      if (state.token_expires_at && moment().unix() > state.token_expires_at) return false;
      return true;
    },
    user(state) {
      return state.user;
    },
    roles(state) {
      return state.roles;
    },
    isAdmin(state) {
      return state.roles.includes('admin');
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    setTokenExpiresAt(state, expires) {
      state.token_expires_at = expires;
      localStorage.setItem('token_expires_at', expires);
    },
    setRoles(state, roles) {
      state.roles = Array.isArray(roles) ? roles : [];
      localStorage.setItem('roles', JSON.stringify(state.roles));
    },
    setDataLogin(state, data) {
      state.user = data.user;
      state.roles = Array.isArray(data.roles) ? data.roles : [];
      localStorage.setItem('roles', JSON.stringify(state.roles));
      state.token = data.access_token;
      const expiresAt = moment().add(data.expires_in, 'minutes').unix();
      state.token_expires_at = expiresAt;
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('token_expires_at', expiresAt);
    },
    clearAuthData(state) {
      state.user = null;
      state.token = '';
      state.token_expires_at = '';
      state.roles = [];
      localStorage.removeItem('roles');
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('token_expires_at');
    },
  },
  actions: {
    async login({ commit }, authData) {
      const { data } = await axios.post('/auth/login', authData);
      commit('setDataLogin', data);
      return data;
    },
    async tryAutoLogin({ commit }) {
      const token = localStorage.getItem('token');
      const expiresAt = localStorage.getItem('token_expires_at');
      const user = localStorage.getItem('user');
      const roles = localStorage.getItem('roles');

      if (!token) return;
      if (expiresAt && moment().unix() > parseInt(expiresAt)) {
        commit('clearAuthData');
        return;
      }

      commit('setToken', token);
      commit('setTokenExpiresAt', expiresAt);
      if (user) {
        commit('setUser', JSON.parse(user));
      }
      if (roles) {
        try {
          commit('setRoles', JSON.parse(roles));
        } catch (e) {
          commit('setRoles', []);
        }
      }
    },
    logout({ commit }) {
      axios.post('/auth/logout').catch(() => {});
      commit('clearAuthData');
    },
    async fetchUser({ commit }) {
      const { data } = await axios.get('/user');
      commit('setUser', data);
      commit('setRoles', data.roles);
    },
  },
});
